/**
 * Created by Amit Panghal
 */

import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TimelineLite} from "gsap";
import {SpacierArcadeReelSymbol} from "./SpacierArcadeReelSymbol";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {SpacierArcadeWildSymbol} from "./SpacierArcadeWildSymbol";
import {SpacierArcadeScatterSymbol} from "./SpacierArcadeScatterSymbol";

export class SpacierArcadeStickySymbol extends PIXI.Container {
    private _stickySymbol:any;
    private _originalReelPosition:PIXI.Point;
    private _originalSymbolName:string;

    constructor(originalSymbolName:string, originalReelPosition:PIXI.Point, multiplier:number, spinIntensity?:number, symState?: ISymbolStateConfig) {
        super();
        this._originalReelPosition = originalReelPosition;
        this._originalSymbolName = originalSymbolName;
        this._stickySymbol = this.getStickySymbol(originalSymbolName, 0);
        this._stickySymbol.symbolSpinIntensity = spinIntensity || 1;
        this._stickySymbol.multiplier = multiplier;
        // if(symState) {
        //     this._stickySymbol.changeState({state: symState ? symState : SpacierArcadeGameConfig.instance.SYMBOL_STATES.sticky});
        // }
        this.addChild(this._stickySymbol);
    }

    private getStickySymbol(symName:string, reelId:number):any{
        switch (symName) {
            case "W":
                return new SpacierArcadeWildSymbol(symName, reelId);
                break;
            case "S":
                return new SpacierArcadeScatterSymbol(symName, reelId);
                break;
            default:
                return new SpacierArcadeReelSymbol(symName, reelId);
                break;
        }
    }

    get stickySymbol():SpacierArcadeReelSymbol{
        return this._stickySymbol;
    }

    get originalReelPosition():PIXI.Point {
        return this._originalReelPosition;
    }

    get originalSymbolName():string {
        return this._originalSymbolName;
    }
}